module.exports = __webpack_public_path__ + "img/banner.8381f3fd.jpg";